import React, { useState } from "react";
import { ScatterChart } from "@sia/style-guide";

function OperatingCostsChart({ translate, metrics, showCustomerData }) {
  const [denominator, setDenominator] = useState("total_fte");
  const costDenominators = metrics.metrics.map((item) => {
    const obj = {
      id: item.metric,
      label: translate(`benchmarking.evaluations.overheads.accounts.operating_costs.${item.metric}`),
      unit: item.metric === "total_fte" ? "CHF" : "%",
      format: item.metric === "total_fte" ? "currency" : "percent",
      decimals: item.metric === "total_fte" ? 0 : 1,
    };
    return obj;
  });
  const active = costDenominators.find((item) => item.id === denominator);
  const title = translate(`benchmarking.evaluations.overheads.accounts.${metrics.costCategory}.${active.id}.title`);
  const operatingKeys = [
    "accounts.space-expenses",
    "accounts.it-expenses-incl-leasing",
    "accounts.office-administrative-expenses",
    "accounts.insurance-fees-charges",
    "accounts.vehicle-expenses-incl-leasing",
    "accounts.ads-acquisition",
    "accounts.other-operating-expenses",
    "accounts.maintenance-repairs",
    "accounts.energy-and-disposal-costs",
  ];
  const costsMetrics = operatingKeys.map((key) => {
    let obj = {};
    obj.id = key;
    obj.label = translate(`benchmarking.evaluations.overheads.${key}`);
    obj.level = 0;
    const values = metrics.metrics.reduce((acc, metric) => {
      const propertyName = metric.metric;
      acc[propertyName] = {};
      const account = metric.accounts.find((e) => e.accountKey === key);
      if (account) {
        acc[propertyName]["customerValue"] = account.companyValue;
        const mean = account.benchmark.mean;
        const stddev = account.benchmark.stddev;
        acc[propertyName]["mean"] = mean;
        if (stddev > mean / 2) {
          acc[propertyName]["sd"] = mean / 2;
        } else {
          acc[propertyName]["sd"] = stddev;
        }
      }
      return acc;
    }, {});
    obj.values = values;
    return obj;
  });

  return (
    <ScatterChart
      translate={translate}
      title={title}
      subtitle={translate(`benchmarking.evaluations.overheads.accounts.${metrics.costCategory}.subtitle`)}
      metrics={costsMetrics}
      denominators={costDenominators}
      denominatorLabel={translate("benchmarking.evaluations.overheads.accounts.denominator")}
      unitLabel={translate("benchmarking.evaluations.overheads.accounts.unit")}
      selectedDenominator={denominator}
      onDenominatorChange={setDenominator}
      showCustomerData={showCustomerData}
    />
  );
}

export default OperatingCostsChart;
